/** Game energy colors and UI palette (design doc §2.1). */

export const COLOR_IDS = ['cyan', 'pink', 'yellow', 'green', 'violet'] as const;
export type ColorId = (typeof COLOR_IDS)[number];

export const COLOR_HEX: Record<ColorId, string> = {
  cyan: '#3DD8FF',
  pink: '#FF7AC8',
  yellow: '#FFE066',
  green: '#5EF0B0',
  violet: '#C4A8FF',
};

export const UI_PALETTE = {
  background: '#152A48',
  surface: '#1E3A5F',
  board: '#1A3354',
  orange: '#FFAA55',
  danger: '#FF5B6E',
  textPrimary: '#F2F7FF',
  textMuted: '#A8C0E0',
} as const;

export function isColorId(value: string): value is ColorId {
  return (COLOR_IDS as readonly string[]).includes(value);
}
